var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$store.state.menubarRouters.full && !this.$route.query.hide
    ? _c(
        "div",
        { staticClass: "menubar" },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "el-menu",
                {
                  ref: "myMenu",
                  staticClass: "el-menu-vertical-demo",
                  attrs: {
                    "default-active": _vm.defaultActive,
                    collapse: _vm.isCollapse,
                    "default-openeds": _vm.openeds,
                  },
                  on: { open: _vm.open },
                },
                [
                  _vm._l(
                    _vm.$store.state.menubarRouters.children,
                    function (val, i) {
                      return !val.hide
                        ? [
                            val.children
                              ? _c(
                                  "el-submenu",
                                  {
                                    key: val.path + i,
                                    attrs: { index: val.path + i.toString() },
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _c("img", {
                                        staticClass: "nav-icon no-ok",
                                        attrs: {
                                          src: require("@/assets/newicons/" +
                                            (val.icon_img || "nav01") +
                                            ".png"),
                                        },
                                      }),
                                      _c("img", {
                                        staticClass: "nav-icon yes-ok",
                                        attrs: {
                                          src: require("@/assets/newicons/" +
                                            (val.icon_img || "nav01") +
                                            "_ok.png"),
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t(val.name))),
                                      ]),
                                    ]),
                                    _vm._l(val.children, function (child, n) {
                                      return !child.hide
                                        ? [
                                            child.children
                                              ? _c(
                                                  "el-submenu",
                                                  {
                                                    key: child.path + n,
                                                    staticClass:
                                                      "submenu-padding",
                                                    attrs: {
                                                      index:
                                                        child.path +
                                                        n.toString(),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(child.name)
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._l(
                                                      child.children,
                                                      function (grondChild) {
                                                        return !grondChild.hide
                                                          ? [
                                                              _c(
                                                                "router-link",
                                                                {
                                                                  key: grondChild.name,
                                                                  attrs: {
                                                                    to:
                                                                      _vm.$store
                                                                        .state
                                                                        .menubarRouters
                                                                        .path +
                                                                      "/" +
                                                                      val.path +
                                                                      "/" +
                                                                      child.path +
                                                                      "/" +
                                                                      grondChild.path,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-menu-item",
                                                                    {
                                                                      attrs: {
                                                                        index:
                                                                          _vm
                                                                            .$store
                                                                            .state
                                                                            .menubarRouters
                                                                            .path +
                                                                          "/" +
                                                                          val.path +
                                                                          "/" +
                                                                          child.path +
                                                                          "/" +
                                                                          grondChild.path,
                                                                        "data-index":
                                                                          _vm
                                                                            .$store
                                                                            .state
                                                                            .menubarRouters
                                                                            .path +
                                                                          "/" +
                                                                          val.path +
                                                                          "/" +
                                                                          child.path +
                                                                          "/" +
                                                                          grondChild.path,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              position:
                                                                                "relative",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                grondChild.name
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          : _vm._e()
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _c(
                                                  "router-link",
                                                  {
                                                    key: child.name,
                                                    attrs: {
                                                      to:
                                                        _vm.$store.state
                                                          .menubarRouters.path +
                                                        "/" +
                                                        val.path +
                                                        "/" +
                                                        child.path,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-menu-item",
                                                      {
                                                        attrs: {
                                                          index:
                                                            _vm.$store.state
                                                              .menubarRouters
                                                              .path +
                                                            "/" +
                                                            val.path +
                                                            "/" +
                                                            child.path,
                                                          "data-index":
                                                            _vm.$store.state
                                                              .menubarRouters
                                                              .path +
                                                            "/" +
                                                            val.path +
                                                            "/" +
                                                            child.path,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(child.name)
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        : _vm._e()
                                    }),
                                  ],
                                  2
                                )
                              : _c(
                                  "el-menu-item",
                                  {
                                    key: i,
                                    class: _vm.isCollapse ? "" : "menu-item",
                                    attrs: {
                                      index:
                                        _vm.$store.state.menubarRouters.path +
                                        "/" +
                                        val.path,
                                      "data-index":
                                        _vm.$store.state.menubarRouters.path +
                                        "/" +
                                        val.path,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickNext(val.path)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "nav-icon no-ok",
                                      attrs: {
                                        src: require("@/assets/newicons/" +
                                          (val.icon_img || "") +
                                          ".png"),
                                      },
                                    }),
                                    _c("img", {
                                      staticClass: "nav-icon yes-ok",
                                      attrs: {
                                        src: require("@/assets/newicons/" +
                                          (val.icon_img || "nav01") +
                                          "_ok.png"),
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "title" },
                                        slot: "title",
                                      },
                                      [_vm._v(_vm._s(_vm.$t(val.meta.title)))]
                                    ),
                                  ]
                                ),
                          ]
                        : _vm._e()
                    }
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }